import React from 'react';

import SearchIcon from '@material-ui/icons/Search';

export default function SearchButton(props)
{
  return {
      color : "inherit",
      label : "検索",
      "aria-label" : "表示するドキュメントの検索条件を変更します。",
      icon : <SearchIcon />,
      ...props
  }
}